module.exports = __webpack_public_path__ + "02_baby.154e4dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_baby.png
// module id = WX3W
// module chunks = 0